import React from 'react';
import Logs from 'components/Logs';

const UserGroupsLogs = ({ id, type }) => {
  let targetType;

  switch (type) {
    case 'DRIVER':
      targetType = 'DriverUserGroup';
      break;
    case 'TASKS':
      targetType = 'TasksExternalUserGroup';
      break;
    case 'CONTRACTOR':
      targetType = 'ContractorExternalUserGroup';
      break;
    case 'EMPLOYEE':
      targetType = 'EmployeeUserGroup';
      break;
    default:
      targetType = 'ParentUserGroup';
      break;
  }

  return (
    <Logs targetId={parseInt(id)} targetType={targetType} title="User Group Logs" height={439} />
  );
};

export default UserGroupsLogs;
